import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_STOCK_METHOD_SUCCESS,
  FETCH_STOCK_METHOD_SUCCESS,
  GET_STOCK_METHOD_SUCCESS,
  SAVE_STOCK_METHOD_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess} from "./Common";
import {getUser} from "./Auth";
import {arrayToCSV, downloadCSV} from "../../util/methods";
import {message} from "antd";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_STOCK_METHOD_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_STOCK_METHOD_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_STOCK_METHOD_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_STOCK_METHOD_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {role} = store.getState();
      const {query} = role;
      const response = await axios.get(`/stock-method?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {role} = store.getState();
      const {query} = role;
      const response = await axios.get(`/stock-method/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect= true, module) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/stock-method`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      if (!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/stock-method');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/stock-method/${id}`, payload);
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/stock-method');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/stock-method/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/stock-method/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
